
/**
 * Room metadata key used to persist Focus Mode for the lifetime of the room, so
 * that the setting survives the moderator who enabled it leaving and rejoining.
 */
export const FOCUS_MODE_METADATA_KEY = 'focusMode';

/**
 * Endpoint message type used to broadcast Focus Mode to the other participants.
 * This is the primary transport; room metadata is only an extra persistence
 * layer and is not available on every deployment.
 */
export const SET_FOCUS_MODE_MESSAGE_TYPE = 'SET_FOCUS_MODE';
